export class DeferredPromise<T> {
  private readonly promise: Promise<T>

  private resolveFunction!: (value: T) => void

  private rejectFunction!: (reason?: unknown) => void

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.resolveFunction = resolve
      this.rejectFunction = reject
    })
  }

  resolve(value: T) {
    this.resolveFunction(value)
  }

  reject(reason?: unknown) {
    this.rejectFunction(reason)
  }

  wait() {
    return this.promise
  }
}
